import { InsurersCodeEnum } from '../../../../enums/insurers-code.enum';

const EXCLUDED_POLICY_STATUSES = new Set([
  'CANCELED',
  'POLICY_EXPIRED',
  'CANCELATION_REQUEST',
]);

export function canSelectPolicyForTransfer(status: string): boolean {
  if (!status) {
    return true;
  }
  return !EXCLUDED_POLICY_STATUSES.has(status);
}

export interface TransferBatchInput {
  status: string;
  insurerCode?: string;
}

export interface TransferBatchEligibility {
  allowed: boolean;
  reason?: string;
}

export function canTransferBatch(batch: TransferBatchInput): TransferBatchEligibility {
  if (batch.insurerCode && batch.insurerCode !== InsurersCodeEnum.Yelum) {
    return {
      allowed: false,
      reason: 'Transferência disponível apenas para lotes Yelum.',
    };
  }

  if (batch.status === 'PROCESSING') {
    return {
      allowed: false,
      reason:
        'Não é possível transferir enquanto o lote está em faturamento (PROCESSING).',
    };
  }

  return { allowed: true };
}

export function canOpenTransferModal(
  selectedCount: number,
  batchEligibility?: TransferBatchEligibility,
): {
  allowed: boolean;
  reason?: string;
} {
  if (batchEligibility && !batchEligibility.allowed) {
    return batchEligibility;
  }

  if (selectedCount === 0) {
    return {
      allowed: false,
      reason: 'Selecione ao menos uma apólice para transferir',
    };
  }
  return { allowed: true };
}

export function allPreviewItemsMatched(
  items: Array<{ status: string }>,
): boolean {
  return (
    items.length > 0 &&
    items.every((item) => item.status === 'matched')
  );
}

export const TRANSFER_CONFIRMATION_MESSAGE =
  'Ao confirmar: os códigos das apólices serão atualizados conforme o lote destino; ' +
  'o lote origem pode ser fechado automaticamente se ficar sem apólices ativas; ' +
  'certificados serão baixados da Yelum e podem ficar pendentes para reprocessamento noturno.';
